module.exports = __webpack_public_path__ + "img/FullRedCol2.0488a688.jpg";